module.exports = __webpack_public_path__ + "static/img/info_bg.48544bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/info_bg.png
// module id = EZVJ
// module chunks = 1